import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const ProvinceComparisonChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={590}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 10, bottom: 80 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="province" angle={-45} textAnchor="end" interval={0} />
        <YAxis />
        <Tooltip />
        <Legend
          layout="horizontal"
          verticalAlign="top"
          align="center"
          wrapperStyle={{ marginBottom: 20 }}
        />
        <Bar dataKey="temples" fill="#8884d8" name="วัด" />
        <Bar dataKey="royal" fill="#d62728" name="พระอารามหลวง" />
        <Bar dataKey="raj" fill="#a0522d" name="วัดราษฎ์" />
        <Bar dataKey="wisung" fill="#ff7f50" name="วิสุงคามสีมา" />
        <Bar dataKey="pattasima" fill="#ffc658" name="พัทธสีมา" />
        <Bar dataKey="monastery" fill="#82ca9d" name="ที่พักสงฆื" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ProvinceComparisonChart;